import { Map, fromJS } from 'immutable';
import {
  updateOptionType,
  toggleRadioOptionType,
  fetchInitialOptionsType,
  toggleCheckboxOptionType,
  createInitialOptionsCopyType,
  updateSavedInfoWithCurrentType,
  setCurrentOptionsSameAsSavedType,
} from './StructureOptionsConstants';

export const initialState = Map({
  initialOption: null,
});

function toggleRadioOptions(options, optionId) {
  return options.map((item) => item.set('checked', false)).setIn([optionId, 'checked'], true);
}

// eslint-disable-next-line default-param-last
export default function structureOptionsReducer(state = initialState, action) {
  switch (action.type) {
    case fetchInitialOptionsType: {
      return state.set('initialOption', action.payload);
    }

    case createInitialOptionsCopyType: {
      const { id, normalizedOptions } = action.payload;
      const information = fromJS({
        current: normalizedOptions,
        saved: normalizedOptions,
      });

      return state.set(id, information);
    }

    case setCurrentOptionsSameAsSavedType: {
      const { id } = action.payload;
      const saved = state.getIn([id, 'saved']);

      return state.setIn([id, 'current'], saved);
    }

    case toggleRadioOptionType: {
      const { path, optionId } = action.payload;

      return state.updateIn(path, (options) => toggleRadioOptions(options, optionId));
    }

    case toggleCheckboxOptionType: {
      const { path } = action.payload;
      const resultPath = path.concat(['checked']);

      return state.setIn(resultPath, !state.getIn(resultPath));
    }

    case updateOptionType: {
      const { path, data } = action.payload;

      return state.updateIn(path, (option) => option.merge(data));
    }

    case updateSavedInfoWithCurrentType: {
      const { id } = action.payload;

      return state.setIn([id, 'saved'], state.getIn([id, 'current']));
    }

    default: {
      return state;
    }
  }
}
